import React, { useEffect, useRef, useState } from "react";
import { MDBAlert, MDBBtn } from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import PDF1 from "../../components/docs/callflow_help.pdf";

function CFFileMenu(props) {
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();
  const [currentSection, setCurrentSection] = useState(null);
  const closeMenu = () => {
    setCurrentSection(null);
  };
  const handleMenuClick = (section) => {
    setCurrentSection((prevSection) =>
      prevSection === section ? null : section
    );
  };

  const onZoom = (data) => {
    if (data.option == 1) {
      props.zoomIn();
    } else if (data.option == 2) {
      props.zoomOut();
    } else if (data.option == 3) {
      props.fitS();
    }
    if (data.option == 4) {
      props.fitFull();
    }
  };
  const handleActions = (actionInfo) => {
    switch (actionInfo.action) {
      case 1:
        props.onSave();
        break;
      case 2:
        props.onClose();
        break;
      case 3:
        props.onSave(1);
        break;
      case 4:
        props.onDelete();
        break;
      case 5:
        props.onUndo();
        break;
      case 6:
        props.onRedo();
        break;
      case 7:
        props.onCopy();
        break;
      case 8:
        props.onNoteshide();
        break;
      case 9:
        MDBAlert("Not available at this moment");
        //props.onShowAnalytics();
        break;
      case 10:
        props.onNodeAlign("LR");
        break;
      case 11:
        onZoom({ option: 1 });
        break;
      case 12:
        onZoom({ option: 2 });
        break;
      case 13:
        onZoom({ option: 3 });
        break;
      case 14:
        onZoom({ option: 4 });
        break;
      case 15:
        alert("Not available at this moment");
        break;
      case 16:
        alert("Not available at this moment");
        break;
      case 17:
        props.feedBack();
        break;
      case 18:
        props.onCut();
        break;
      case 19:
        props.onPaste({ x: 0, y: 0 });
        break;
    }
  };
  return (
    <>
      <ul className="d-flex">
        <nav>
          <div onMouseOut={() => closeMenu()}>
            <ul className="d-flex callflowMainMenu">
              <div onMouseOver={() => handleMenuClick("file")}>
                <li>
                  File
                  {currentSection === "file" && (
                    <ul className="callFlow_MenuItems">
                      {/* {props.cando && (
                        <>
                          <li className="inactive">
                            <div>Save</div>
                          </li>
                        </>
                      )}
                      {!props.cando && ( */}
                        <>
                          <li className="">
                            <div onClick={(e) => handleActions({ action: 1 })}>
                              Save
                            </div>
                          </li>
                        </>
                      {/* )} */}
                      <li>
                        <div onClick={(e) => handleActions({ action: 2 })}>
                          Close
                        </div>
                      </li>
                      {/* {props.cando && (
                        <>
                          <li className="inactive">
                            <div> Save and Close</div>
                          </li>
                        </>
                      )}
                      {!props.cando && ( */}
                        <>
                          <li className="">
                            <div onClick={(e) => handleActions({ action: 3 })}>
                              Save and Close
                            </div>
                          </li>
                        </>
                      {/* )} */}
                      {/* {props.copy && (
                        <>
                          <li className="">
                            <div onClick={(e) => handleActions({ action: 4 })}>
                              Delete and Add Note
                            </div>
                          </li>
                        </>
                      )} */}
                      {/* {!props.copy && (
                        <>
                          <li className="inactive">
                            <div>Delete and Add Note</div>
                          </li>
                        </>
                      )} */}
                    </ul>
                  )}
                </li>
              </div>
              <div onMouseOver={() => handleMenuClick("edit")}>
                <li>
                  Edit
                  {currentSection === "edit" && (
                    <ul className="callFlow_MenuItems">
                      {props.cando && (
                        <>
                          <li className="inactive">
                            <div>Undo</div>
                          </li>
                        </>
                      )}
                      {!props.cando && (
                        <>
                          <li className="">
                            <div onClick={(e) => handleActions({ action: 5 })}>
                              Undo
                            </div>
                          </li>
                        </>
                      )}
                      {props.redo && (
                        <>
                          <li className="inactive">
                            <div>Redo</div>
                          </li>
                        </>
                      )}
                      {!props.redo && (
                        <>
                          <li className="">
                            <div onClick={(e) => handleActions({ action: 6 })}>
                              Redo
                            </div>
                          </li>
                        </>
                      )}

                      {/* {props.copy && (
                        <>
                          <li className="">
                            <div onClick={(e) => handleActions({ action: 18 })}>
                              Cut
                            </div>
                          </li>
                        </>
                      )}
                      {!props.copy && (
                        <>
                          <li className="inactive">
                            <div>Cut</div>
                          </li>
                        </>
                      )} */}
                      {props.copy && (
                        <>
                          <li className="">
                            <div onClick={(e) => handleActions({ action: 7 })}>
                              Copy
                            </div>
                          </li>
                        </>
                      )}
                      {!props.copy && (
                        <>
                          <li className="inactive">
                            <div>Copy</div>
                          </li>
                        </>
                      )}
                      {props.paste && (
                        <>
                          <li className="">
                            <div onClick={(e) => handleActions({ action: 19 })}>
                              Paste
                            </div>
                          </li>
                        </>
                      )}
                      {!props.paste && (
                        <>
                          <li className="inactive">
                            <div>Paste</div>
                          </li>
                        </>
                      )}
                    </ul>
                  )}
                </li>
              </div>
              <div onMouseOver={() => handleMenuClick("view")}>
                <li>
                  View
                  {currentSection === "view" && (
                    <ul className="callFlow_MenuItems">
                      <li>
                        <div onClick={(e) => handleActions({ action: 8 })}>
                          {props.hide && <>Unhide Notes</>}
                          {!props.hide && <>Hide Notes</>}
                        </div>
                      </li>

                      <li>
                        <div onClick={(e) => handleActions({ action: 10 })}>
                          Align Nodes
                        </div>
                      </li>
                      <li>
                        <div onClick={(e) => handleActions({ action: 11 })}>
                          Zoom In
                        </div>
                      </li>
                      <li>
                        <div onClick={(e) => handleActions({ action: 12 })}>
                          Zoom Out
                        </div>
                      </li>
                      <li>
                        <div onClick={(e) => handleActions({ action: 13 })}>
                          Zoom to Fit
                        </div>
                      </li>
                      <li>
                        <div onClick={(e) => handleActions({ action: 14 })}>
                          Zoom to 100%
                        </div>
                      </li>
                      {/* <li className="inactive">
                        <div onClick={(e) => handleActions({ action: 9 })}>
                          Show Call Analytics Snapshot
                        </div>
                      </li> */}
                    </ul>
                  )}
                </li>
              </div>
              <div onMouseOver={() => handleMenuClick("help")}>
                <li>
                  Help
                  {currentSection === "help" && (
                    <ul className="callFlow_MenuItems">
                      {/* <li>
                        <div onClick={(e) => handleActions({ action: 15 })}>
                          Tutorial
                        </div>
                      </li> */}
                      {/* <li>
                        <a className="" href={PDF1} target="_blank" rel="noreferrer">
                          Help Docs
                        </a>
                      </li> */}
                      <li>
                        <div onClick={(e) => handleActions({ action: 17 })}>
                          Leave Feedback
                        </div>
                      </li>
                    </ul>
                  )}
                </li>
              </div>
            </ul>
          </div>
        </nav>
      </ul>
    </>
  );
}

export default CFFileMenu;
